import { render } from "./CatalogSection.vue?vue&type=template&id=de4f1770"
import script from "./CatalogSection.vue?vue&type=script&lang=js"
export * from "./CatalogSection.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tin/Documents/asket/stone-xxi.ru-v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__